import { VisitDto, VisitTypeDto } from '@ecdlink/core';
import { v4 as uuidv4 } from 'uuid';

export function computeMotherVisits(
  motherId: string,
  expectedDateOfDelivery: Date | null,
  registeredDate: Date,
  visitTypes: VisitTypeDto[]
): VisitDto[] {
  if (!expectedDateOfDelivery) return [];

  const endTermDate = new Date(expectedDateOfDelivery);
  const startTermDate = new Date(endTermDate);
  startTermDate.setDate(startTermDate.getDate() - 280);

  const day = (offset: number) => {
    const d = new Date(startTermDate);
    d.setDate(d.getDate() + offset);
    return d;
  };

  let visit1Date: Date | null = null;
  let visit2Date: Date | null = null;
  let visit3Date: Date | null = null;
  let visit4Date: Date | null = null;

  let bAddVisit1 = true;
  let bAddVisit2 = true;
  let bAddVisit3 = true;
  let bAddVisit4 = true;

  const rd = registeredDate;

  if (rd < day(98)) {
    visit1Date = day(97);
    visit2Date = day(168);
    visit3Date = day(196);
    visit4Date = day(279);
  } else if (rd >= day(98) && rd <= day(153)) {
    visit1Date = addDays(rd, 7);
    visit2Date = day(168);
    visit3Date = day(196);
    visit4Date = day(279);
  } else if (rd >= day(154) && rd <= day(182)) {
    visit1Date = addMonths(rd, 1);
    visit2Date = addMonths(rd, 2);
    visit3Date = addMonths(rd, 3);
    visit4Date = day(279);
  } else if (rd >= day(183) && rd <= day(258)) {
    visit1Date = addDays(rd, 7);
    visit2Date = addDays(rd, 14);
    visit3Date = addDays(rd, 21);
    visit4Date = day(279);
  } else if (rd >= day(259) && rd <= day(265)) {
    visit1Date = addDays(rd, 7);
    visit2Date = addDays(rd, 14);
    visit3Date = day(279);
    visit4Date = day(279);
  } else if (rd >= day(266) && rd <= day(273)) {
    visit1Date = day(279);
    visit2Date = day(279);
    bAddVisit3 = false;
    bAddVisit4 = false;
  } else if (rd > day(273)) {
    visit1Date = day(279);
    bAddVisit2 = false;
    bAddVisit3 = false;
    bAddVisit4 = false;
  }

  const result: VisitDto[] = [];

  if (bAddVisit1 && visit1Date) {
    result.push(
      createVisit(visit1Date, visit2Date ?? visit1Date, visitTypes[0], motherId)
    );
  }
  if (bAddVisit2 && visit2Date) {
    result.push(
      createVisit(visit2Date, visit3Date ?? visit2Date, visitTypes[1], motherId)
    );
  }
  if (bAddVisit3 && visit3Date) {
    result.push(
      createVisit(visit3Date, visit4Date ?? visit3Date, visitTypes[2], motherId)
    );
  }
  if (bAddVisit4 && visit4Date) {
    result.push(createVisit(visit4Date, visit4Date, visitTypes[3], motherId));
  }

  return result.sort((a, b) => a.visitType?.order! - b.visitType?.order!);
}

function createVisit(
  plannedDate: Date,
  nextDate: Date,
  type: VisitTypeDto,
  motherId: string
): VisitDto {
  const dueDate = addDays(nextDate, -1);

  return {
    id: uuidv4(),
    dueDate: dueDate.toISOString(),
    actualVisitDate: '',
    attended: false,
    isCancelled: false,
    startedDate: '',
    plannedVisitDate: plannedDate.toISOString(),
    orderDate: dueDate.toISOString(),
    visitType: type,
    insertedDate: new Date().toISOString(),
    clientId: motherId,
    visitAnswers: [],
  };
}

function addDays(date: Date, days: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

function addMonths(date: Date, months: number): Date {
  const result = new Date(date);
  result.setMonth(result.getMonth() + months);
  return result;
}
